export default __webpack_public_path__ + "static/SR USA - Safety Data Sheet - Caramel Color (Liquid)-6d6ade86d18d9bff9e74de881fb7bc97.pdf";